import { useState, useMemo } from "react";
import { Search } from "lucide-react";

export default function SearchBar({ value, onChange, placeholder = "Search…", testId }) {
  return (
    <div className="relative flex-1 max-w-md">
      <Search className="absolute left-3 top-2.5 h-4 w-4 text-slate-400" />
      <input
        data-testid={testId}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className="w-full pl-9 pr-3 py-2 text-sm border border-slate-200 rounded-md bg-white focus:border-orange-500 outline-none transition-colors duration-150"
      />
    </div>
  );
}

export function useLocalFilter(items, q, keys) {
  return useMemo(() => {
    if (!q || q.length < 1) return items;
    const s = q.toLowerCase();
    return items.filter((it) => keys.some((k) => String(it?.[k] ?? "").toLowerCase().includes(s)));
  }, [items, q, keys]);
}

export { useState };
